import { put, takeEvery, select } from 'redux-saga/effects';
import { startSubmit, stopSubmit } from 'redux-form';
import { push } from 'connected-react-router';
import { notificationsAdd } from 'virtues-bootstrap';
import { FORM_NAMES } from 'constants/forms';

import {
  parsePdf,
  uploadCardioVascularReport,
  storePdfReport,
} from 'store/actionCreators/newCardioReport';
import {
  requestPostDocumentReference,
  requestPostDocumentReferenceFailure,
} from 'store/actionCreators/documentReference';
import { getCreatedCardioReportData } from 'store/selectors/newCardioReport';
import { getPatientPageUrlId } from 'store/selectors/router';
import { createSagaRace } from 'utilities/request';
import i18n from 'services/i18n';
import { getUniqId } from 'utilities';

export function* handleParsePdf(action) {
  const { file } = action.payload;

  const formData = new FormData();
  formData.set('pdfFile', file);

  const pdfBase64 = file;

  yield put(storePdfReport(pdfBase64));
}

export function* handleReportCreate() {
  try {
    yield put(startSubmit(FORM_NAMES.uploadCardioReport));
    const patientId = yield select(getPatientPageUrlId);
    const observationData = yield select(getCreatedCardioReportData);
    yield put(requestPostDocumentReference({ data: observationData }));
    const { success } = yield createSagaRace(requestPostDocumentReference);
    yield put(stopSubmit(FORM_NAMES.uploadCardioReport));

    if (success) {
      yield put(push(`/patient/${patientId}/cardiovascular-reports`));
      yield put(
        notificationsAdd({
          id: getUniqId(),
          variant: 'success',
          title: i18n.t('common:requestSuccess'),
          description: i18n.t('common:reports.cardioReportUploadedSuccess'),
        }),
      );
      return;
    }
  } catch (error) {
    yield put(
      notificationsAdd({
        id: getUniqId(),
        variant: 'danger',
        title: i18n.t('common:requestError'),
        description: error.toString(),
      }),
    );
    yield put(requestPostDocumentReferenceFailure(error));
    yield put(stopSubmit(FORM_NAMES.uploadCardioReport));
  }
}

export default function*() {
  yield takeEvery(parsePdf, handleParsePdf);
  yield takeEvery(uploadCardioVascularReport, handleReportCreate);
}
